import { useApiQuery } from '@portals-platform/api-client';
import { ENDPOINTS } from '../api/endpoints.js';
import type { CurrentUserResponse } from '../api/responses.js';
import { queryKeys } from '../query-keys.js';

export function useCurrentUser() {
  return useApiQuery<CurrentUserResponse>([...queryKeys.currentUser()], ENDPOINTS.currentUser);
}
